import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import styles from './MobileToast.module.scss';

/**
 * 모바일 토스트 컴포넌트
 * - 헤더 아래에 표시되는 토스트 알림
 * - 일정 시간 후 자동으로 사라짐
 * @param {string} message - 표시할 메시지
 * @param {boolean} isVisible - 토스트 표시 여부
 * @param {function} onClose - 토스트가 사라질 때 호출되는 콜백
 * @param {number} duration - 표시 시간 (ms), 기본값 2500ms
 */
function MobileToast({ message, isVisible, onClose, duration = 2500 }) {
  const [isShowing, setIsShowing] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(
    function () {
      if (isVisible) {
        // 토스트 표시
        setIsShowing(true);
        // 약간의 딜레이 후 애니메이션 시작 (DOM 렌더링 대기)
        requestAnimationFrame(function () {
          setIsAnimating(true);
        });

        // 일정 시간 후 사라지기
        const hideTimer = setTimeout(function () {
          setIsAnimating(false);
        }, duration);

        // 애니메이션 완료 후 완전히 숨기기
        const removeTimer = setTimeout(function () {
          setIsShowing(false);
          if (onClose) {
            onClose();
          }
        }, duration + 300); // 애니메이션 시간 300ms 추가

        return function () {
          clearTimeout(hideTimer);
          clearTimeout(removeTimer);
        };
      }
    },
    [isVisible, duration, onClose],
  );

  if (!isShowing) {
    return null;
  }

  return createPortal(
    <div className={`${styles.container} ${isAnimating ? styles.visible : ''}`}>
      <div className={styles.toast}>
        <span className={styles.message}>{message}</span>
      </div>
    </div>,
    document.body,
  );
}

export default MobileToast;
